import { type RefSelectProps as BaseSelectRef, type SelectProps } from "antd"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import SelectComponent from "../../../../../components/Select"
import {
  APPOINTMENT_TYPES,
  EVENT_FORM_APPOINTMENT_TYPES,
  appointmentTypeLabelKey
} from "../../constants/appointment-types.ts"

export const CalendarAddAppointmentTypeSelect = React.forwardRef<
  BaseSelectRef,
  SelectProps
>((props, ref) => {
  const { t } = useTranslation()

  // All eight, not the picker's seven: a stored value outside the offered set
  // still needs a label, or SelectComponent renders it as "Unavailable".
  // Memoised because SelectComponent keys its own memo on these two by identity.
  const { options, fallbackLabels } = useMemo(() => {
    const labels = Object.fromEntries(
      APPOINTMENT_TYPES.map((value) => [
        value,
        t(appointmentTypeLabelKey(value))
      ])
    )

    return {
      options: EVENT_FORM_APPOINTMENT_TYPES.map((value) => ({
        value,
        label: labels[value]
      })),
      fallbackLabels: labels
    }
  }, [t])

  return (
    <SelectComponent
      ref={ref}
      size="large"
      options={options}
      fallbackLabels={fallbackLabels}
      placeholder={t("appointmentType.placeholder")}
      {...props}
    />
  )
})

CalendarAddAppointmentTypeSelect.displayName =
  "CalendarAddAppointmentTypeSelect"
